// KDM Group content sourced from official brochure

export const KDM_STATS = [
  { value: "15+", label: "Years of Excellence" },
  { value: "5", label: "Countries" },
  { value: "600+", label: "Workforce" },
  { value: "6", label: "Verticals" },
];

export const VERTICALS = [
  {
    id: "hospitality",
    number: "01",
    title: "Hospitality & Tourism",
    summary:
      "Flagship resorts, immersive travel experiences and a strategic partnership with one of the world's largest hotel chains.",
    image:
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/8k88woyh_bluewhaleresortkdmhotels.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/8k88woyh_bluewhaleresortkdmhotels.jpeg",
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/yuf9ntqk_peock%20villa.jpg",
    ],
    entities: [
      {
        name: "KDM Hotels Pvt Ltd",
        text: "Sole owner and developer of the Blue Whale Resort in Kalpitiya — successfully operated for over a decade.",
        link: { label: "bluewhaleresort.com", href: "https://www.bluewhaleresort.com" },
      },
      {
        name: "KDM Touring Company",
        text: "A dedicated travel arm delivering seamless logistics and curated guest experiences for 10+ years.",
      },
      {
        name: "UNA Hotels Partnership · Melissa's Riviera",
        text: "An Italian-linked development where UNA, one of the world's largest hotel groups, intends to operate a dedicated hotel.",
        link: { label: "melissasriviera.com", href: "https://melissasriviera.com/" },
      },
    ],
  },
  {
    id: "real-estate",
    number: "02",
    title: "Real Estate & Infrastructure",
    summary:
      "A decade of land development and global brokerage anchored in Italian design standards.",
    image:
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/5602swkm_kdm%20milano.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/5602swkm_kdm%20milano.webp",
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/d54rsmnr_14_milano_portaVolta.jpg",
    ],
    entities: [
      {
        name: "KDM Property Developers & Skyland Pvt Ltd",
        text: "Leading property management firms with a sizeable Sri Lankan portfolio of land sales and successful developments.",
      },
      {
        name: "KDM Global Services SRL — Milan, Italy",
        text: "Nominated entity for international property development and hotel management services; acts as a global brokerage for high-value assets.",
      },
      {
        name: "Strategic Partnerships",
        text: "Provider of prime land assets to major national retailers across the region.",
      },
    ],
  },
  {
    id: "trade",
    number: "03",
    title: "International Trade & Manufacturing",
    summary:
      "Vertical garment production for the USA, EU and Canada, premium Italian imports and green-energy exports from Spain.",
    image:
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/6zu8r2dl_Screenshot%202026-05-20%20at%2001.35.35.png",
    images: [
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/6zu8r2dl_Screenshot%202026-05-20%20at%2001.35.35.png",
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/kj6lx5wl_Screenshot%202026-05-20%20at%2001.35.48.png",
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/dj5j7lf8_Screenshot%202026-05-20%20at%2003.12.14.png",
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/5d8wukmp_Screenshot%202026-05-20%20at%2003.11.10.png",
    ],
    entities: [
      {
        name: "Ital Lanka Import & Export Pvt Ltd",
        text: "Decade-long relationships with premium Italian brands — embedding Italian quality across every project.",
      },
      {
        name: "KDM Global Apparels Pvt Ltd — Dhaka",
        text: "Vertical knit garment factory employing 600+ workers, producing high-end apparel for the USA, EU and Canada.",
        link: {
          label: "Download Company Profile (PDF)",
          href: "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/84yfifqf_KDM%20Apparels%201.pdf",
        },
      },
      {
        name: "J&M Blue Whale Services SLU — Girona, Spain",
        text: "Specialising in international green-energy solutions and the export of Italian services and products.",
        link: {
          label: "jmbluewhaleservices.com",
          href: "https://jmbluewhaleservices.com/",
        },
      },
    ],
  },
  {
    id: "technology",
    number: "04",
    title: "Technology & Back-Office",
    summary:
      "An IT arm with 15 years of operations, generating consistent foreign income and powering BPO bridges across continents.",
    image:
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/gm4pwzhw_Gemini_Generated_Image_5ptcer5ptcer5ptc.png",
    entities: [
      {
        name: "Anwarnet Pvt Ltd",
        text: "The IT arm of KDM Group with 15 years of experience, managing an international client portfolio and consistently generating foreign income for Sri Lanka.",
      },
      {
        name: "KDM Global Inc — USA",
        text: "Facilitates back-office and BPO services between US companies and group hubs in Sri Lanka and Bangladesh.",
      },
    ],
  },
  {
    id: "lifestyle",
    number: "05",
    title: "Lifestyle & Brand Equity",
    summary:
      "Alahakoon Investments — the engine behind the globally recognised Melissa's brand spanning Italy and Sri Lanka.",
    image:
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/va4gynl1_melissas%20yakkala.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/va4gynl1_melissas%20yakkala.jpeg",
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/r6pj2e8z_WhatsApp%20Image%202026-05-11%20at%2011.59.43.jpeg",
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/oqgpud7o_WhatsApp%20Image%202026-05-11%20at%2011.59.56.jpeg",
    ],
    entities: [
      {
        name: "Alahakoon Investments Pvt Ltd",
        text: "The investment engine of the group and sole owner of the globally recognised Melissa's brand.",
      },
      {
        name: "Melissa's Dining Portfolio",
        text: "Famous locations include Melissa's Milano (Italy), Melissa's Food Court (Yakkala) and Melissa's Kalpitiya.",
        link: { label: "melissas.lk", href: "https://melissas.lk/" },
      },
    ],
  },
  {
    id: "leadership",
    number: "06",
    title: "Leadership & Vision",
    summary:
      "Diplomatic credentials, deep technical foundations and a strategic bridge between Italian quality and Sri Lankan growth.",
    image:
      "https://customer-assets.emergentagent.com/job_kdm-web-portal/artifacts/du27pqwg_Gemini_Generated_Image_28yar328yar328ya.png",
    entities: [
      {
        name: "Diplomatic Credentials",
        text: "Mr. Alahakoon has been officially nominated as the Sri Lankan B.I.O. (Bureau of International Organizations) Representative in Italy.",
      },
      {
        name: "Technical Foundation",
        text: "A background in high-level telecommunications and IT — the driving force behind the group's digital transformation and the 15-year success of Anwarnet.",
      },
      {
        name: "Strategic Bridge",
        text: "Under his leadership, the group has integrated Italian design and quality into the Sri Lankan real estate landscape, establishing Melissa's Riviera as a premier international asset.",
      },
    ],
  },
];

export const COUNTRIES = [
  { code: "LK", name: "Sri Lanka", role: "Real Estate, Hospitality, Retail & Group HQ" },
  { code: "IT", name: "Italy", role: "Property Development & Strategic Partnerships" },
  { code: "ES", name: "Spain", role: "Green Energy Solutions & Export Services" },
  { code: "BD", name: "Bangladesh", role: "Manufacturing & Apparel Exports" },
  { code: "US", name: "USA", role: "Business Operations & BPO Services" },
];

export const FLAGSHIP_BRANDS = [
  { label: "BLUE WHALE RESORT", href: "https://www.bluewhaleresort.com" },
  { label: "MELISSA'S RIVIERA", href: "https://melissasriviera.com/" },
  { label: "MELISSA'S RESTAURANTS", href: "https://melissas.lk/" },
  { label: "MELISSA'S MILANO" },
  { label: "KDM PROPERTY" },
  { label: "ANWARNET" },
  { label: "ITAL LANKA" },
  { label: "KDM GLOBAL APPARELS" },
  { label: "J&M BLUE WHALE" },
  { label: "KDM TOURING" },
  { label: "SKYLAND" },
];

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/ce1d0218-2de5-4a12-a043-aa5761b21c7b/images/5e99ade579a274a0b5f585fcc1285466b6a1f5ffa3b2dd34db3c270bc68cf65e.png";
